import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { isDefinedString, reduce } from "et3-type-guards";
import { DEFAULT_TIME } from "../../../constants/input-entries-constants";
import { TKhattabatMessage } from "../../../Types";
import getKhattabatStore from "..";
import getCorePopUpStore from "../../core/core-popup-store";
import { apiCallSendOneOOneMessage } from "../../../api/khattbat-api/api-call-send-one-o-one-message";
import { khattabaConversationParsing } from "../../../helpers/et3-conversation-parse";
import getKhattabatSharedMessagingStore from "./conversation-messaging-store";
import getKhattabat101MMessagingStore from "../101m-stores/101m-messaging-store";
import getKhattabat101CMessagingStore from "../101c-stores/101c-messaging-store";
import getKhattabatFilterStore from "../filter-store";

class Khattabat101MessagingStore {
  conversationID = observable.box<string>("");
  receiverID = observable.box<number>(0);
  receiverUUID = observable.box<string>("");
  receiverName = observable.box<string>("");
  senderID = observable.box<number>(0);
  senderUUID = observable.box<string>("");
  senderName = observable.box<string>("");

  sendMessage = async () => {
    const conversationID = this.conversationID.get();
    const sharedStore = getKhattabatSharedMessagingStore(conversationID);
    const conversationType = sharedStore.conversationType.get();
    const messageText = khattabaConversationParsing(
      sharedStore.messageField.get()
    );
    const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
    const receiverUUID = this.receiverUUID.get();
    const receiverID = this.receiverID.get();

    if (
      sharedStore.isSending.get() ||
      !isDefinedString(alkhattabaUUID) ||
      !isDefinedString(receiverUUID) ||
      !isDefinedString(messageText)
    ) {
      return;
    }
    runInAction(() => {
      sharedStore.isSending.set(true);
    });
    const { status, code, data } = await apiCallSendOneOOneMessage({
      alkhattabaText: messageText,
      userID: receiverID,
      conversationType
    });
    runInAction(() => {
      sharedStore.isSending.set(false);
    });
    if (status === "OK") {
      const databaseCurrentTime = reduce(
        () => data.messageCurrentTime,
        DEFAULT_TIME
      );
      const oneOOneMessageToAdd: TKhattabatMessage = {
        isKhattabaMessage: 1,
        isClientMessage: 0,
        message: messageText,
        messageType: "text",
        createdOn: databaseCurrentTime,
        isSeen: 1,
        senderGender: "f",
        conversationId: conversationID
      };
      const isComments =
        conversationType === "101C_COMMENTS" ||
        conversationType === "101M_COMMENTS";
      const isOneOOneMConversation = conversationType === "101M";

      if (isComments) {
        sharedStore.appendMessage(oneOOneMessageToAdd);
      } else {
        const messagingStore = isOneOOneMConversation
          ? getKhattabat101MMessagingStore(receiverID)
          : getKhattabat101CMessagingStore(receiverID);
        messagingStore.handleMessageSent({
          conversationID,
          oneOOneMessageToAdd
        });
        messagingStore.markMessagesSeen();
      }
      sharedStore.setMessageField("");
      getKhattabatFilterStore().update1o1MFilter();
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getKhattabat101MessagingStore = memoize((conversationID: string) => {
  const store = new Khattabat101MessagingStore();
  store.conversationID.set(conversationID);
  return store;
});
export default getKhattabat101MessagingStore;
